(function () {
    function syncPlayState(card, video, playBtn) {
      var playing = !!video && !video.paused;
      if (card) card.classList.toggle('is-playing', playing);
      if (!playBtn) return;
      playBtn.classList.toggle('is-playing', playing);
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      var playIcon = playBtn.querySelector('.asteri-vstory-card__icon--play');
      var pauseIcon = playBtn.querySelector('.asteri-vstory-card__icon--pause');
      if (playIcon) playIcon.hidden = playing;
      if (pauseIcon) pauseIcon.hidden = !playing;
    }

    function syncMuteState(video, muteBtn) {
      if (!muteBtn) return;
      var muted = video.muted;
      muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      var mutedIcon = muteBtn.querySelector('.asteri-vstory-card__icon--muted');
      var unmutedIcon = muteBtn.querySelector('.asteri-vstory-card__icon--unmuted');
      if (mutedIcon) mutedIcon.hidden = !muted;
      if (unmutedIcon) unmutedIcon.hidden = muted;
    }

    function toggleVideo(video) {
      if (!video) return;
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    }

    function loadVideo(video) {
      if (!video || video.dataset.vstoryLoaded === '1') return;

      // Applied before the sources so the frame paints while the video is still loading.
      if (video.dataset.poster) {
        video.poster = video.dataset.poster;
        video.removeAttribute('data-poster');
      }

      var sources = video.querySelectorAll('source[data-src]');

      sources.forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.dataset.vstoryLoaded = '1';
      video.load();
    }

    /* The section observer only tells us the rail is approaching, not which cards
       are on screen — it is a carousel, so most of them are not. Watching each
       video separately keeps the off-screen posters unfetched until they are
       swiped towards; on mobile that is four of the five. */
    function observeVideos(root) {
      var videos = root.querySelectorAll('[data-vstory-lazy-video]');

      if (!('IntersectionObserver' in window)) {
        videos.forEach(loadVideo);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            loadVideo(entry.target);
          });
        },
        {
          // Enough to cover the neighbouring card, so a swipe never lands on an
          // empty frame.
          rootMargin: '200px',
          threshold: 0
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });

      root._vstoryVideoObserver = observer;
    }

    function initCard(card) {
      if (card.dataset.vstoryReady) return;
      var video = card.querySelector('video');
      var playBtn = card.querySelector('[data-vstory-play]');
      var muteBtn = card.querySelector('[data-vstory-mute]');
      if (!video || !playBtn || !muteBtn) return;

      card.dataset.vstoryReady = '1';
      video.setAttribute('playsinline', '');
      video.muted = true;
      syncPlayState(card, video, playBtn);
      syncMuteState(video, muteBtn);

      muteBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        video.muted = !video.muted;
        syncMuteState(video, muteBtn);
      });

      video.addEventListener('play', function () {
        syncPlayState(card, video, playBtn);
      });

      video.addEventListener('pause', function () {
        syncPlayState(card, video, playBtn);
      });
    }

    function isHomeMobile() {
      return document.documentElement.classList.contains('home-mobile');
    }

    function playCenteredSlide(slider) {
      var active = slider.track.details.rel;

      slider.slides.forEach(function (slide, index) {
        var card = slide.querySelector('[data-vstory-card]');
        var video = slide.querySelector('video');
        var isActive = index === active;

        if (card) card.classList.toggle('is-active', isActive);

        if (!video) return;

        video.muted = true;
        syncMuteState(video, slide.querySelector('[data-vstory-mute]'));

        if (isActive && !isHomeMobile()) {
          // Loaded here rather than waiting on the observer: its callback is
          // async, so on first paint this would otherwise ask a video with no
          // sources yet to play and silently fail.
          loadVideo(video);
          video.play().catch(function () {});
        } else {
          video.pause();
        }

        if (card) {
          syncPlayState(card, video, slide.querySelector('[data-vstory-play]'));
        }
      });
    }

    function bindSlideClicks(root, slider) {
      slider.slides.forEach(function (slide, index) {
        var card = slide.querySelector('[data-vstory-card]');
        if (!card || card.dataset.vstoryClickBound) return;
        card.dataset.vstoryClickBound = '1';

        card.addEventListener('click', function (event) {
          if (event.target.closest('a, [data-vstory-mute]')) return;

          var active = slider.track.details.rel;
          if (index !== active) {
            slider.moveToIdx(index);
            return;
          }

          toggleVideo(card.querySelector('video'));
        });
      });
    }

    function calcCardWidthPx(root, track) {
      var gap = Number(root.dataset.vstoryGap || 16);
      var visible = Math.max(1, Number(root.dataset.vstoryVisible || 5));
      var containerWidth = track.clientWidth || root.clientWidth;
      // Mobile: ~1.4 cards so one is centered with peeks of neighbors (matches original).
      // Desktop keeps the section's visible_cards (5).
      if (containerWidth < 750) visible = 1.4;
      var totalGaps = gap * Math.max(0, visible - 1);
      var width = Math.floor((containerWidth - totalGaps) / visible);
      return Math.max(120, width);
    }

    function applyCardWidth(root, track, widthPx) {
      root.style.setProperty('--vstory-width', widthPx + 'px');
      track.querySelectorAll('[data-vstory-slide]').forEach(function (slide) {
        slide.style.minWidth = widthPx + 'px';
        slide.style.maxWidth = widthPx + 'px';
      });
      track.querySelectorAll('[data-vstory-card]').forEach(function (card) {
        card.style.setProperty('--vstory-width', widthPx + 'px');
      });
    }

    function syncCardWidth(root, slider) {
      var track = root.querySelector('[data-vstory-slider]');
      if (!track) return;
      var widthPx = calcCardWidthPx(root, track);
      applyCardWidth(root, track, widthPx);
      if (slider) slider.update();
    }

    function initSlider(root) {
      var track = root.querySelector('[data-vstory-slider]');
      if (!track || track.dataset.vstorySliderReady || typeof KeenSlider === 'undefined') return;

      var gap = Number(root.dataset.vstoryGap || 16);
      var canLoop = track.querySelectorAll('[data-vstory-slide]').length > 1;

      applyCardWidth(root, track, calcCardWidthPx(root, track));
      track.dataset.vstorySliderReady = '1';

      var slider = new KeenSlider(track, {
        loop: canLoop,
        mode: 'free-snap',
        rubberband: false,
        slides: {
          origin: 'center',
          perView: 'auto',
          spacing: gap
        },
        created: function (instance) {
          track.classList.add('keen-slider--ready');
          syncCardWidth(root, instance);
          bindSlideClicks(root, instance);
          playCenteredSlide(instance);
        },
        slideChanged: function (instance) {
          playCenteredSlide(instance);
        },
        destroyed: function () {
          delete track.dataset.vstorySliderReady;
          track.classList.remove('keen-slider--ready');
        }
      });

      if (typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(function () {
          syncCardWidth(root, slider);
        });
        resizeObserver.observe(track);
        root._vstoryResizeObserver = resizeObserver;
      } else {
        var onResize = function () {
          syncCardWidth(root, slider);
        };
        window.addEventListener('resize', onResize);
        root._vstoryOnResize = onResize;
      }

      root._vstorySlider = slider;
    }

    function initSection(root) {
      if (root.dataset.vstoryObserved === '1') return;

      root.dataset.vstoryObserved = '1';

      function loadSection() {
        observeVideos(root);

        root
          .querySelectorAll('[data-vstory-card]')
          .forEach(initCard);

        initSlider(root);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              observer.disconnect();
              root._vstoryIntersectionObserver = null;

              loadSection();
            });
          },
          {
            rootMargin: '300px 0px',
            threshold: 0
          }
        );

        observer.observe(root);
        root._vstoryIntersectionObserver = observer;
      } else {
        loadSection();
      }
    }

    function waitForKeen(callback) {
      if (typeof KeenSlider !== 'undefined') {
        callback();
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof KeenSlider !== 'undefined') {
          clearInterval(timer);
          callback();
        } else if (attempts > 40) {
          clearInterval(timer);
        }
      }, 50);
    }

    function initAll() {
      waitForKeen(function () {
        document.querySelectorAll('[data-vstory-section]').forEach(initSection);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-vstory-section]');
      if (section) {
        waitForKeen(function () {
          initSection(section);
        });
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.querySelector('[data-vstory-section]');
      if (!section) return;

      if (section._vstoryResizeObserver) {
        section._vstoryResizeObserver.disconnect();
        section._vstoryResizeObserver = null;
      }

      if (section._vstoryVideoObserver) {
        section._vstoryVideoObserver.disconnect();
        section._vstoryVideoObserver = null;
      }

      if (section._vstoryOnResize) {
        window.removeEventListener('resize', section._vstoryOnResize);
        section._vstoryOnResize = null;
      }

      if (section._vstorySlider) {
        section._vstorySlider.destroy();
        section._vstorySlider = null;
      }
    });
  })();
